import styled from 'styled-components'

export const MainContainer = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
`
export const SkillsContainer = styled.ul`
    list-style-type: none;
    padding-left: 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`
export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffdd95;
  margin: 20px 0px 20px 0px;
`
export const Loader = styled.div`
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`